import(/* webpackMode: "eager" */ "/vercel/path0/src/app/candidates/page.tsx");
